import { TFunction } from 'i18next';

export const hmsFormatter = (value: number) => {
    const hours = Math.floor(value / 3600);
    const remainder = value % 3600;
    const minutes = Math.floor(remainder / 60);
    const seconds = remainder % 60;

    return `${hours.toString().padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}:${Math.round(seconds).toString().padStart(2, '0')}`;
};

export const hmsUsageFormatter = ({
    defaultMessage,
    value,
    t
}: {
    defaultMessage: string;
    value: number;
    t: TFunction;
}) => {
    const hours = Math.floor(value / 3600);
    const remainder = value % 3600;
    const minutes = Math.floor(remainder / 60);

    if (hours > 0) {
        return t('Common.time.numberOfHours', { count: hours, hours });
    }
    if (minutes > 30) {
        return t('Common.time.lessThanOneHour');
    }
    if (minutes > 15) {
        return t('Common.time.lessThan30min');
    }
    if (minutes > 5) {
        return t('Common.time.lessThan15min');
    }
    if (minutes > 0) {
        return t('Common.time.lessThan5min');
    }
    return defaultMessage;
};
